import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';

@Component({
    selector: 'app-dialog-requested-changes-component',
    templateUrl: './dialog-request-changes.component.html',
    styleUrls: ['./dialog-request-changes.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatDialogModule, FormsModule, ReactiveFormsModule, MatLegacyButtonModule]
})
export class DialogRequestedChangesComponent implements OnInit {
    public requestedChangesForm: UntypedFormGroup;
    public changeText: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly dialogRef: MatDialogRef<DialogRequestedChangesComponent>
    ) {}

    ngOnInit(): void {
        const params: any = {
            changeText: new UntypedFormControl('', [Validators.required])
        };
        this.requestedChangesForm = new UntypedFormGroup(params);
    }

    public requestChanges() {
        if (!this.requestedChangesForm.valid) {
            return;
        }

        const result = {
            hasChanges: true,
            requestedChanges: this.requestedChangesForm.get('changeText').value
        };
        this.dialogRef.close(result);
    }

    public close() {
        const result = {
            hasChanges: false
        };
        this.dialogRef.close(result);
    }

    hasError = (controlName: string, errorName: string) => {
        return this.requestedChangesForm.controls[controlName].hasError(errorName);
    };
}
